<template>
    <input
        ref="input"
        :autofocus="autofocus"
        :style="styleObject"
        :disabled="disabled"
        :value="label"
        @input="e => (label = e.target.value)"
        @blur="syncLabelAndValue"
    />
</template>

<script>
function format(value) {
    if (!isNaN(value)) {
        return value.toFixed(2);
    }
    return value;
}

export default {
    props: {
        value: {
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        styleObject: {
            type: Object,
            required: false
        }
    },
    data: () => ({
        forceChange: 0,
        label: ""
    }),
    created() {
        this.syncLabelAndValue();
    },
    mounted() {
        if (this.autofocus) {
            this.$refs.input.focus();
        }
    },
    watch: {
        value() {
            if (this.$refs.input !== document.activeElement) {
                this.syncLabelAndValue();
            }
        },
        label(label) {
            try {
                const normalized = label.replace(",", ".");
                const value = eval(normalized);
                if (typeof value !== "number" || isNaN(value)) return;
                this.$emit("input", value);
            } catch (err) {}
        }
    },
    methods: {
        syncLabelAndValue() {
            if (typeof this.value === "string") {
                this.label = "";
            } else {
                this.label = format(this.value).toString();
            }
        },
        changed(e) {
            // we force a redraw of the input, otherwise it will show more than 2 digits after the ,
            const value = Number.parseFloat(e.target.value);
            this.forceChange++;
            if (isNaN(value)) return;
            this.$emit("input", value);
        }
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// number-input.vue?3e842d2b